import { useNavigate, useSearch } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { FoodGroup, SearchIngredient } from '@/api/types'
import { Button } from '@/components/Button'
import { PageEditHeader } from '@/components/PageEditHeader'
import FCDBIngredientImporter from '../FCDBIngredientImporter/FCDBIngredientImporter'
import IngredientsTableFilters from '../IngredientsTableFilters/IngredientsTableFilters'
import { IngredientsSearchParams } from '@/routes/ingredients.fcdb'
import IngredientsTable from '../IngredientsTable/IngredientsTable'

type Props = {
  ingredients: SearchIngredient[]
  foodGroups: FoodGroup[]
  totalCount: number
  handleToggleVisibility: (ingredientId: number, state: boolean) => void
}

export default function FCDBIngredientsPanel({
  ingredients,
  foodGroups,
  totalCount,
  handleToggleVisibility,
}: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const searchParams = useSearch({ from: '/ingredients/fcdb' })

  const removeLangualFilter = () => {
    navigate({
      to: '/ingredients/fcdb',
    })
  }

  function setSearchParams<K extends keyof IngredientsSearchParams>(
    key: K,
    value: IngredientsSearchParams[K],
  ) {
    navigate({
      to: '.',
      search: (search) => ({
        ...search,
        [key]: value,
        page: 0,
      }),
    })
  }

  return (
    <>
      <PageEditHeader title={t('ingredient.fcdbIngredients')} style={{ marginTop: 32 }}>
        <FCDBIngredientImporter />
      </PageEditHeader>

      <div style={{ display: 'flex', gap: '50px', marginTop: '10px' }}>
        <IngredientsTableFilters
          filters={searchParams}
          foodGroups={foodGroups}
          setSearchParams={setSearchParams}
        />
        <div style={{ flexGrow: 1 }}>
          {searchParams.languaLID && searchParams.languaLID.length > 0 && (
            <div className="RecipeFilters" style={{ marginTop: '-35px', position: 'absolute' }}>
              {t('ingredient.filterByLangual')}
              <div className="RecipeFilters-tag">
                {searchParams.languaLID}
                <Button onPress={removeLangualFilter} slot="remove">
                  <svg
                    height="14"
                    width="14"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                    focusable="false">
                    <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                  </svg>
                </Button>
              </div>
            </div>
          )}
          <div>
            <IngredientsTable
              ingredients={ingredients}
              totalCount={totalCount}
              handleToggleVisibility={handleToggleVisibility}
            />
          </div>
        </div>
      </div>
    </>
  )
}
